import React from "react";
import {
  Button,
  Dialog,
  List,
  ListItem,
  DialogActions,
  DialogTitle,
  TextField,
  CircularProgress,
  Switch,
  FormControlLabel,
} from "@material-ui/core";
import { useTranslation } from "localization/translation";
import { FlagIcon } from "react-flag-kit";
import Select from "components/select";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { dateFormatter } from "helpers/dateFormatter";

const { RangePicker } = DatePicker;

const dateFormat = "YYYY-MM-DD";

const AcceptUserModal = ({
  isUserModal = true,
  isShowPlans = false,
  isShowFreeTrial = false,
  text,
  accept,
  close,
  isOpen,
  isShowBranchCount,
  branchCount,
  setBranchCount,
  isShowLanguage,
  setLang,
  lang,
  loading,
  plans,
  currencies,
  handleChangePlanData,
  planData,
  errorUserDefaultPlan,
}) => {
  
  const translation = useTranslation();

  const changeLanguage = () => {
    setLang((st) => (st === "hy" ? "ru" : st === "ru" ? "en" : "hy"));
  };

  const disablePastDates = (current) => {
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    return current && current < now;
  };

  const handleDateChange = (dates) => {
    if (!dates || dates.length !== 2) {
      handleChangePlanData('free_trial_start_at', null);
      handleChangePlanData('free_trial_end_at', null);
      handleChangePlanData('trial_period_days', 0);
      return;
    }
  
    const start = dates[0].format('YYYY-MM-DD');
    const end = dates[1].format('YYYY-MM-DD');
    handleChangePlanData('free_trial_start_at', start);
    handleChangePlanData('free_trial_end_at', end);
  
    const days =
      dates[1].startOf('day').diff(dates[0].startOf('day'), 'day') + 1;
  
    handleChangePlanData('trial_period_days', days);
  };

  return (
    <Dialog
      classes={{
        paper: `modal-content rounded-lg paperWidthMd`,
      }}
      maxWidth="lg"
      open={isOpen}
      onClose={close}
      aria-labelledby="form-dialog-title"
    >
      <div className="user-modal-wrapper">
        <form onSubmit={accept}>
          <DialogTitle className="p-4">{text}</DialogTitle>
          {
            isUserModal && (
              <>
                <div className="top-content text_field_center px-4">
                  {isShowBranchCount && (
                    <div className="text_field_center">
                      <TextField
                        id="outlined-basic"
                        label={translation.branches_count}
                        variant="outlined"
                        value={branchCount}
                        type="number"
                        onChange={(e) => setBranchCount(e.target.value)}
                      />
                    </div>
                  )}
                  {isShowLanguage && (
                    <div className="laguage_wrapper">
                      <p>{translation.user_invite_language}</p>
                      <ListItem button disableRipple onClick={changeLanguage}>
                        <FlagIcon
                          code={lang === "hy" ? "AM" : lang === "ru" ? "RU" : "US"}
                          size={44}
                        />
                        <div className="divider" />
                      </ListItem>
                    </div>
                  )}
                </div>
                <div className="divider" />
              </>
            )
          }
          {
            !!isShowPlans && (
              <>
                <div className="plans_wrapper px-4 py-4">
                  <List component="div" className="nav-tabs nav-tabs-primary d-flex">
                    {
                      plans?.map((plan) => {
                        return (
                          <ListItem
                            key={plan.id}
                            button
                            disableRipple
                            selected={plan.id === planData?.plan_id}
                            onClick={() => {
                              handleChangePlanData('plan_id', plan.id);
                            }}
                          >
                            <span>{plan.name_hy}</span>
                            <div className="divider" />
                          </ListItem>
                        )
                      })
                    }
                  </List>
                  <div className="divider" />
                  <List component="div" className="nav-tabs nav-tabs-primary d-flex">
                    <ListItem
                      button
                      disableRipple
                      selected={planData?.plan_type === "monthly"}
                      onClick={() => {
                        handleChangePlanData('plan_type', "monthly");
                      }}
                    >
                      <span>{translation.monthly}</span>
                      <div className="divider" />
                    </ListItem>
                    <ListItem
                      button
                      disableRipple
                      selected={planData?.plan_type === "annual"}
                      onClick={() => {
                        handleChangePlanData('plan_type', "annual");
                      }}
                    >
                      <span>{translation.annual}</span>
                      <div className="divider" />
                    </ListItem>
                  </List>
                  <div>
                    <TextField
                      type="number"
                      label={translation.plan_price}
                      variant="outlined"
                      className="w-40 my-2"
                      value={+planData?.price}
                      onChange={(e) => {
                        handleChangePlanData('price', e.target.value);
                      }}
                    />
                    <Select
                      onChange={(val) => {
                        handleChangePlanData('currency', val)
                      }}
                      value={planData?.currency}
                      field={'code'}
                      label={translation.currency}
                      noCard
                      options={currencies}
                      className="ml-4 my-0 mr-auto w-25"
                    />
                  </div>
                  {
                    !!isShowFreeTrial && (
                      <>
                        <div className="divider" />
                        <div className="d-block align-items-center ">
                          <div>
                            <FormControlLabel
                              control={
                                <div className="m-2">
                                  <Switch
                                    onClick={(e) => {
                                      handleChangePlanData('is_use_free_trial', e.target.checked);
                                    }}
                                    checked={!!planData?.is_use_free_trial}
                                    className="switch-medium toggle-switch-first"
                                  />
                                </div>
                              }
                              label={translation.free_trial_active}
                            />
                          </div>
                          {
                            !!planData?.is_use_free_trial && (
                              <div className="my-3">
                                <div className="mb-2">
                                  <span>{translation.free_trial_duration}</span>
                                </div>
                                <RangePicker
                                  onChange={(date) => {                              
                                    handleDateChange(date)
                                  }}
                                  popupClassName="custom-range-picker"
                                  disabledDate={disablePastDates}
                                  placeholder={[
                                    translation.start_date_picker,
                                    translation.end_date_picker,
                                  ]}
                                  value={
                                    planData.free_trial_start_at &&
                                    planData.free_trial_end_at && [
                                      dayjs(dateFormatter(planData.free_trial_start_at, dateFormat), dateFormat),
                                      dayjs(dateFormatter(planData.free_trial_end_at, dateFormat), dateFormat),
                                    ]
                                  }
                                />
                                {
                                  !!errorUserDefaultPlan && (
                                    <p className="font-size-sm text-danger mt-2">{errorUserDefaultPlan}</p>
                                  )
                                }
                              </div>
                            )
                          }
                        </div>
                      </>
                    )
                  }
                  <div className="divider" />
                  <div className="d-block align-items-center ">
                    {
                      !!Object.prototype.hasOwnProperty.call(planData, 'auto_subscription_start') && (
                        <div>
                          <FormControlLabel
                            control={
                              <div className="m-2">
                                <Switch
                                  onClick={(e) => {
                                    handleChangePlanData('auto_subscription_start', e.target.checked);
                                  }}
                                  checked={!!planData?.auto_subscription_start}
                                  className="switch-medium toggle-switch-first"
                                />
                              </div>
                            }
                            label={translation.auto_start_subscription}
                          />
                        </div>
                      )
                    }
                    {
                      !!Object.prototype.hasOwnProperty.call(planData, 'auto_renew') && (
                        <div>
                          <FormControlLabel
                            control={
                              <div className="m-2">
                                <Switch
                                  onClick={(e) => {
                                    handleChangePlanData('auto_renew', e.target.checked);
                                  }}
                                  checked={!!planData?.auto_renew}
                                  className="switch-medium toggle-switch-first"
                                />
                              </div>
                            }
                            label={translation.auto_renew}
                          />
                        </div>
                      )
                    }
                    <div>
                      <FormControlLabel
                        control={
                          <div className="m-2">
                            <Switch
                              onClick={(e) => {
                                handleChangePlanData('unlimited_items', e.target.checked);
                              }}
                              checked={!!planData?.unlimited_items}
                              className="switch-medium toggle-switch-first"
                            />
                          </div>
                        }
                        label={translation.is_unlimited_inventories}
                      />
                    </div>
                    {
                      !planData?.unlimited_items && (
                        <div className="d-flex w-100">
                          <TextField
                            type="number"
                            label={translation.max_inventories_count + "(" + translation.ml + ")"}
                            variant="outlined"
                            className="w-50 my-2 mr-2"
                            value={planData?.max_inventory_items_ml}
                            onChange={(e) => {
                              handleChangePlanData('max_inventory_items_ml', e.target.value);
                            }}
                          />
                          <TextField
                            type="number"
                            label={translation.max_inventories_count + "(" + translation.kg + "/" + translation.pc + ")"} 
                            variant="outlined"
                            className="w-50 my-2 ml-2"
                            value={planData?.max_inventory_items_kg_pc}
                            onChange={(e) => {
                              handleChangePlanData('max_inventory_items_kg_pc', e.target.value);
                            }}
                          />
                        </div>
                      )
                    }
                  </div>
                </div>
                <div className="divider" />
              </>
            )
          }
          <DialogActions className="d-flex mx-auto p-4">
            <Button
              onClick={close}
              variant="contained"
              type="button"
              className="m-2"
            >
              {translation.no}
            </Button>
            <Button
              color="secondary"
              type="submit"
              variant="contained"
              disabled={loading}
            >
              {loading ? <CircularProgress size={20} /> : translation.yes}
            </Button>
          </DialogActions>
        </form>

      </div>
    </Dialog>
  );
};

export default AcceptUserModal;
